import { Flex, Text, Spinner } from '@chakra-ui/react';

import formatPriceNumber from '~/utils/formatPriceNumber';

type CheckoutBarProps = {
  disabled: boolean;
  isOrderer?: boolean;
  isLoading: boolean;
  total: number;
  onClick?: () => void;
};

export default function CheckoutBar({
  disabled,
  total,
  isLoading,
  isOrderer = true,
  onClick,
}: CheckoutBarProps) {
  return (
    <Flex
      bgColor={disabled ? 'gray.400' : isLoading ? 'gray.400' : isOrderer ? 'secondary' : '#B3A694'}
      justify="space-between"
      px={2}
      py={4}
      cursor={isLoading || !isOrderer || disabled ? 'not-allowed' : 'pointer'}
      onClick={() => {
        !disabled && !isLoading && isOrderer && onClick?.();
      }}
    >
      <Text color="white" fontWeight="bold">
        {formatPriceNumber(total)}
      </Text>
      {isLoading ? (
        <Spinner color="white" />
      ) : (
        <Text color="white" fontWeight="bold">
          {disabled
            ? isOrderer
              ? '請確認輸入內容是否正確'
              : '僅有團長可以下單'
            : isOrderer
            ? '確認下單'
            : '僅有團長可以下單'}
        </Text>
      )}
    </Flex>
  );
}
